/* eslint-disable */
var React = require('react');
var SpriteSymbol = require("../node_modules/svg-baker-runtime/browser-symbol.js");
var sprite = require("../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");

var symbol = new SpriteSymbol({
  "id": "car-stationwagen-dd323a45--sprite",
  "use": "car-stationwagen-dd323a45--sprite-usage",
  "viewBox": "0 0 53 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 53 20\" id=\"car-stationwagen-dd323a45--sprite\"><path d=\"M2 7l1.81 7.242a1 1 0 00.97.758H10M2 7h15M2 7l5.203-5.676A1 1 0 017.94 1H18m0 0l-1 6m1-6h9.5M40 7h7a5 5 0 015 5v2a1 1 0 01-1 1h-5m-6-8l-7.733-5.8a1 1 0 00-.6-.2H27.5M40 7H27.5M46 15a4 4 0 01-8 0m8 0a4 4 0 00-8 0m0 0H18m0 0a4 4 0 01-8 0m8 0a4 4 0 00-8 0m7-8h10.5m0 0V1\" stroke=\"#000\" stroke-width=\"2\" /><path d=\"M27.5 7H17l3 6h7.5m0-6H40l-4 6h-8.5m0-6v6m-25-4H5v2H3m49-1h-3l-3-3\" stroke=\"#000\" stroke-width=\".75\" /></symbol>"
});
sprite.add(symbol);

var SvgSpriteIcon = function SvgSpriteIcon(props) {
  return React.createElement(
    'svg',
    Object.assign({
      viewBox: symbol.viewBox
    }, props),
    React.createElement(
      'use',
      {
        xlinkHref: '#' + symbol.id
      }
    )
  );
};

SvgSpriteIcon.viewBox = symbol.viewBox;
SvgSpriteIcon.id = symbol.id;
SvgSpriteIcon.content = symbol.content;
SvgSpriteIcon.url = symbol.url;
SvgSpriteIcon.toString = symbol.toString;

module.exports = SvgSpriteIcon;
module.exports.default = SvgSpriteIcon;
